import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);

  const toggleSidebar = useCallback(() => setSidebarCollapsed(prev => !prev), []);
  const toggleMoreMenu = useCallback(() => setMoreMenuOpen(prev => !prev), []);
  const closeMoreMenu = useCallback(() => setMoreMenuOpen(false), []);

  const value = useMemo(() => ({
    sidebarCollapsed,
    setSidebarCollapsed,
    toggleSidebar,
    moreMenuOpen,
    setMoreMenuOpen,
    toggleMoreMenu,
    closeMoreMenu,
  }), [sidebarCollapsed, moreMenuOpen, toggleSidebar, toggleMoreMenu, closeMoreMenu]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};
